import Vue from 'vue';
import i18n from '@/plugins/i18n';
import vuetify from '@/plugins/vuetify';

// Registra metodos globais
Vue.prototype.$setLocale = (locale) => {
    i18n.locale = locale;
    vuetify.framework.lang.current = locale;
    localStorage.setItem('app-locale', locale);
}

Vue.prototype.$setTheme = (isDark) => {
    vuetify.framework.dark = isDark;
    localStorage.setItem('app-theme', isDark);
}
